/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Highlight_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Highlight Previous Event" |
*
* @param {Shortcut_Keys_Name_Highlight_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_highlight_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Highlight_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Highlight_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'evenement precedent a la selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis hervorheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evidenzia evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выделить предыдущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Destacar evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回顾上一活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントをハイライト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली घटना को हाइलाइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Destaque do evento anterior")
	return /** @type {LocalizedString} */ ("Highlight Previous Event")
});